/* eslint-disable no-underscore-dangle */
class DateRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('date-column');
    this._rootElem.component = this._model;

    this._registerListeners();
    this.render();
  }

  /** ***************************************** */
  /* START PRIVATE COMPONENT RENDERER METHODS */
  /** ***************************************** */
  _shutdown() {
    const prom = new Promise((resolve) => {
      this._unregisterListeners();
      this._model = undefined;
      this._rootElem.remove();
      this._rootElem = undefined;
      resolve();
    });
    return prom;
  }

  _registerListeners() {
    this._model.on('Date', (this._onDate = this._onDate.bind(this)));
  }

  _unregisterListeners() {
    this._model.removeAllListeners('Date');
  }

  /** **************************************** */
  /* END PRIVATE COMPONENT RENDERER METHODS  */
  /* START PUBLIC COMPONENT RENDERER METHODS */
  /** **************************************** */
  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */
  render() {
    const prom = new Promise((resolve /* ,reject */) => {
      this._setDate(this._model.getValue());
      resolve();
    });
    return prom;
  }

  get rootElement() {
    return this.getRootElement();
  }

  getRootElement() {
    return this._rootElem;
  }

  get model() {
    return this.getModel();
  }

  getModel() {
    return this._model;
  }
  /** **************************************** */
  /* END COMPONENT RENDERER METHODS */
  /* START HANDLER METHODS */
  /** **************************************** */

  _onDate(newVal) {
    this._setDate(newVal);
  }

  /** **************************************** */
  /* END HANDLER METHODS */
  /* START PRIVATE API METHODS */
  /** **************************************** */

  _setDate(newVal) {
    if (newVal) {
      this._rootElem.innerHTML = `${new Date(newVal).toLocaleDateString()}
            ${new Date(newVal).toLocaleTimeString()}`;
    } else {
      this._rootElem.innerHTML = '';
    }
  }

  /** **************************************** */
  /*  END PRIVATE API METHODS */
  /** **************************************** */
}

export default DateRenderer;
